export default __webpack_public_path__ + "static/media/icon_chart_active.9f7a20a1.svg";